import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import 'lib-flexible'//rem
import '@/icons' // icon
import Mixin from '@/mixins/message'
import '@/permission' // permission control


// set ElementUI lang to EN
Vue.use(ElementUI,{size:'small'})
Vue.mixin(Mixin)
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
